var ZipByCountySelect = (function ($) {

    var initSelectorGroup = function (countySelect, citySelect, zipSelect) {
        if ($(countySelect).length > 0) {
            var actualCounty = $(countySelect).val()
                || $(countySelect).data("previous-selected");

            if ($(countySelect).val() !== actualCounty){
                $(countySelect).val(actualCounty).trigger('change.select2');
            }

            populateCitySelectBox(countySelect, citySelect, zipSelect, actualCounty);
            addCountyChangeHandler(countySelect, citySelect, zipSelect);
            addCityChangeHandler(countySelect, citySelect, zipSelect);
            addZipChangeHandler(countySelect, citySelect, zipSelect);
        } else {
            populateZipSelectBox(countySelect, zipSelect, citySelect, $(citySelect).val(), undefined);
            addCityChangeHandler(countySelect, citySelect, zipSelect);
            addZipChangeHandler(countySelect, citySelect, zipSelect);
        }
    };

    var addCountyChangeHandler = function (countySelect, citySelect, zipSelect) {
        $(countySelect).on("change", function (event) {
            var target = $(event.target);
            populateCitySelectBox(countySelect, citySelect, zipSelect, target.val());
        });
    };

    var addCityChangeHandler = function (countySelect, citySelect, zipSelect) {
        $(citySelect).on("change", function (event) {
            var target = $(event.target);
            populateZipSelectBox(countySelect, zipSelect, citySelect, target.val(), $(countySelect).val());
        });
    };

    var addZipChangeHandler = function (countySelect, citySelect, zipSelect) {
        $(zipSelect).on("change", function (event) {
            var citySelectBox = $(citySelect);
            var url = "/checkout/zip";
            var city = $(citySelect).val();

            if (citySelectBox.length > 0 && url && city) {
                $.ajax({
                    url: url + "?county=" + $(countySelect).val() + "&city=" + city,
                    type: "GET",
                    cache: true,
                    success: function (data) {
                        var newZipCode = true;
                        if (data) {
                            $.each(data, function (i, zip) {
                                if ($(zipSelect).val() === '' || $(zipSelect).val() === zip) {
                                    newZipCode = false;
                                }
                            });
                        }
                        if ($(zipSelect).val() === "") {
                            newZipCode = false;
                        }
                        var divName = "zipCodeMessage." + $(zipSelect).selector;
                        var divElement = document.getElementById(divName);
                        if (divElement) {
                            divElement.hidden = newZipCode ? false : true;
                        }
                    },
                    error: function (xhr, textStatus, errorThrown) {
                    }
                });
            }
        });
    };
    /**
     * If county value equal to previous selected county value, then return previous selected city or zip,
     * in other case return city or zip from local storage
     */
    var getActualValue = function(countySelect, otherSelect){
        if (countySelect.val() === countySelect.data("previous-selected")) {
            return otherSelect.data("previous-selected");
        }
    };

    var populateCitySelectBox = function (countySelect, citySelect, zipSelect, county) {
        var countySelectBox = $(countySelect);
        var citySelectBox = $(citySelect);

        var url = "/checkout/city";
        var previousSelected = getActualValue(countySelectBox, citySelectBox);
        var defaultCityValue = citySelectBox.find(".j-default-town-value").html();

        disableCitySelectBox(citySelect);
        clearCitySelectBox(citySelect);
        $(zipSelect).find('option:selected').prop('selected', false);
        $(zipSelect).find('option[value=""]').prop('selected', true).trigger('change.select2');

        disableZipSelectBox(zipSelect);

        if (countySelectBox.length > 0 && url && county) {
            $.ajax({
                url: url + "?county=" + county,
                type: "GET",
                cache: true,
                success: function (data) {
                    citySelectBox.find("option").remove();
                    citySelectBox.append($('<option>', {
                        value: "",
                        text: defaultCityValue,
                        class: "j-default-town-value"
                    }));
                    if (data) {
                        var selected = false;
                        if (data.length === 1) {
                            selected = true;
                        }
                        $.each(data, function (i, city) {
                            var option = $('<option>', {value: city, text: city});
                            option.prop('selected', selected || (previousSelected === city));
                            citySelectBox.append(option);
                        });
                    }

                    citySelectBox.trigger('change');

                    citySelectBox.prop("disabled", false);
                },
                error: function (xhr, textStatus, errorThrown) {
                    clearCitySelectBox(citySelect);
                    disableCitySelectBox(citySelect);
                }
            });
        }
    };

    var populateZipSelectBox = function (countySelect, zipSelect, citySelect, city, county) {
        var countySelectBox = $(countySelect);
        var zipSelectBox = $(zipSelect);
        var citySelectBox = $(citySelect);

        var url = "/checkout/zip";
        var previousSelected = getActualValue(countySelectBox, zipSelectBox);
        var defaultZipValue = zipSelectBox.find(".j-default-zip-value").html();
        var initial = zipSelectBox.data("initial-load");

        disableZipSelectBox(zipSelect);
        clearZipSelectBox(zipSelect);

        if (citySelectBox.length > 0 && url && city) {
            zipSelectBox.prop("disabled", true);
            $.ajax({
                url: url + "?county=" + county + "&city=" + city,
                type: "GET",
                cache: true,
                success: function (data) {
                    zipSelectBox.find("option").remove();
                    zipSelectBox.append($('<option>', {
                        value: "",
                        text: defaultZipValue,
                        class: "j-default-zip-value"
                    }));
                    if (data) {
                        var selected = false;
                        var zipSelected = false;
                        var previousSelectedCity = getActualValue(countySelectBox, citySelectBox);

                        if (initial && previousSelected && previousSelected != '') {
                            $.each(data, function (i, zip) {
                                var option = $('<option>', {
                                    value: zip,
                                    text: zip
                                });
                                option.prop('selected', previousSelected == zip);
                                zipSelectBox.append(option);

                                if(previousSelected == zip){
                                    zipSelected = true;
                                }
                            });

                            if (!zipSelected && previousSelectedCity===citySelectBox.val()) {
                                var option = $('<option>', {
                                    value: previousSelected,
                                    text: previousSelected
                                });
                                option.prop('selected', true);
                                zipSelectBox.append(option);
                            }
                        } else {
                            if (data.length === 1) {
                                selected = true;
                            }
                            $.each(data, function (i, zip) {
                                var option = $('<option>', {
                                    value: zip,
                                    text: zip
                                });
                                option.prop('selected', selected);
                                zipSelectBox.append(option);
                            });
                        }
                    }

                    zipSelectBox.data("initial-load", false);

                    zipSelectBox.trigger('change');

                    zipSelectBox.prop("disabled", false);
                },
                error: function (xhr, textStatus, errorThrown) {
                    clearZipSelectBox(zipSelect);
                    disableZipSelectBox(zipSelect);
                }
            });
        }
    };

    function clearCitySelectBox(citySelect) {
        var citySelectBox = $(citySelect);
        var defaultCityValue = citySelectBox.find(".j-default-town-value").html();

        citySelectBox
            .find('option')
            .remove()
            .end()
            .append($('<option>', {
                value: "",
                text: defaultCityValue,
                class: "j-default-town-value"
            }))
            .prop('selected', true)
            .trigger('change');
    }

    function clearZipSelectBox(zipSelect) {
        var zipSelectBox = $(zipSelect);
        var defaultZipValue = zipSelectBox.find(".j-default-zip-value").html();

        zipSelectBox
            .find('option')
            .remove()
            .end()
            .append($('<option>', {
                value: "",
                text: defaultZipValue,
                class: "j-default-zip-value"
            }))
            .prop('selected', true)
            .trigger('change');

        var divName = "zipCodeMessage." + zipSelectBox.selector;
        var divElement = document.getElementById(divName);
        if (divElement) {
            divElement.hidden = true;
        }
    }

    function disableCitySelectBox(citySelect) {
        $(citySelect).prop("disabled", true);
    }

    function disableZipSelectBox(zipSelect) {
        $(zipSelect).prop("disabled", true);
    }

    return {
        initSelectorGroup: initSelectorGroup
    }
})(jQuery);

function initZipByCounty() {
    ZipByCountySelect.initSelectorGroup("select.invoice-zip-county-select", "select.invoice-zip-town-select",
        "select.invoice-zip-select");
    ZipByCountySelect.initSelectorGroup("select.delivery-zip-county-select", "select.delivery-zip-town-select",
        "select.delivery-zip-select");
    ZipByCountySelect.initSelectorGroup("select.billing-zip-county-select", "select.billing-zip-town-select",
        "select.billing-zip-select");
}

function initZipByCountySelectGroup() {
    $.each($("select[class*='delivery-zip-town-select']"), function (i, select) {
        $.each(select.classList, function (i, element) {
            if (element.match('delivery-zip-town-select')) {
                var pieces = element.split(['-']);
                var selectGroupId = pieces[pieces.length - 1];

                var countySelect = "select.delivery-zip-county-select-" + selectGroupId;
                var townSelect = "select.delivery-zip-town-select-" + selectGroupId;
                var zipSelect = "select.delivery-zip-select-" + selectGroupId;

                if (typeof $(countySelect).select2 !== 'undefined') {
                    $(countySelect).select2();
                    $(townSelect).select2();
                    $(zipSelect).select2({
                        tags: true
                    });
                }

                ZipByCountySelect.initSelectorGroup(countySelect, townSelect, zipSelect);
            }
        });
    })
}

jQuery(function () {
    initZipByCounty();
});
